module.exports = __webpack_public_path__ + "img/whatsapp.d0b57470.png";